/**
 * Toast notification utility using SweetAlert2
 */

import Swal from "sweetalert2";

export const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast: HTMLElement) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

export const showSuccessToast = (message: string) => {
  Toast.fire({
    icon: "success",
    title: message,
  });
};

export const showErrorToast = (message: string) => {
  Toast.fire({
    icon: "error",
    title: message,
  });
};

export const showWarningToast = (message: string) => {
  Toast.fire({
    icon: "warning",
    title: message,
  });
};

export const showInfoToast = (message: string) => {
  Toast.fire({
    icon: "info",
    title: message,
  });
};

export const showConfirm = async (
  title: string,
  text: string,
  confirmButtonText = "Yes",
  cancelButtonText = "Cancel",
): Promise<boolean> => {
  const result = await Swal.fire({
    title,
    text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#ef4444",
    cancelButtonColor: "#6b7280",
    confirmButtonText,
    cancelButtonText,
  });

  return result.isConfirmed;
};

export const showDeleteConfirm = async (
  itemName: string,
  itemType = "item",
): Promise<boolean> => {
  const result = await Swal.fire({
    title: `Delete ${itemType}?`,
    html: `Are you sure you want to delete <strong>${itemName}</strong>?<br/>This action cannot be undone.`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#ef4444",
    cancelButtonColor: "#6b7280",
    confirmButtonText: "Yes, delete it",
    cancelButtonText: "Cancel",
  });

  return result.isConfirmed;
};
